import React from 'react';

// Styles
import styles from "./ConsultantTextReportsDetails.module.css";

// Image
import userProfile from "./../../../../../assets/img/DashboardICons/userProfileTest.png";

const ConsultantTextReportsDetailsChats = () => {
    return (
        <div dir="rtl" className={`mx-4 mt-3 px-2 py-3 ${styles.consultanttextreportchats_container}`}>
            <div className={`px-3 ${styles.consultanttextreportchats_row}`}>
                {/* Date */}
                <span className={`d-flex justify-content-center align-items-center bg-white my-0 mx-auto ${styles.consultanttextreportchats_date}`}>
                    ۳ مهر
                </span>
                {/* Box Right */}
                <div dir="rtl" className={`d-flex align-items-start position-relative my-4 ${styles.consultanttextreportchats_box}`}>
                    <img className={`ms-1 ${styles.consultanttextreportchats_avatar}`} src={userProfile} alt="avatar-chat-img" />
                    <div style={{ width: "40%" }}>
                        <p className={`d-flex bg-white mb-0 mx-2 px-3 py-2 text-right ${styles.consultanttextreportchats_text}`}>
                            لورم ایپسوم متن ساختگی با تولید سادگی نامفهوم از
                            صنعت چاپ و با استفاده از طراحان گرافیک است
                        </p>
                        <span className={`mx-2 ${styles.consultanttextreportchats_time}`}>۱۳:۵۰</span>
                    </div>
                </div>
                {/* Box Left */}
                <div dir="ltr" className={`d-flex align-items-start position-relative my-4 ${styles.consultanttextreportchats_box}`}>
                    <img className={`ms-1 ${styles.consultanttextreportchats_avatar}`} src={userProfile} alt="avatar-chat-img" />
                    <div style={{ width: "40%" }} className="text-right">
                        <p className={`d-flex bg-white mb-0 mx-2 px-3 py-2 text-right ${styles.consultanttextreportchats_text}`}>
                            لورم ایپسوم متن ساختگی با تولید سادگی نامفهوم از
                            صنعت چاپ و با استفاده از طراحان گرافیک است
                        </p>
                        <span className={`mx-2 ${styles.consultanttextreportchats_time}`}>۱۳:۵۱</span>
                    </div>
                </div>
                <div dir="rtl" className={`d-flex align-items-start position-relative my-4 ${styles.consultanttextreportchats_box}`}>
                    <img className={`ms-1 ${styles.consultanttextreportchats_avatar}`} src={userProfile} alt="avatar-chat-img" />
                    <div style={{ width: "40%" }}>
                        <p className={`d-flex bg-white mb-0 mx-2 px-3 py-2 text-right ${styles.consultanttextreportchats_text}`}>
                            لورم ایپسوم متن ساختگی با تولید سادگی نامفهوم از
                            صنعت چاپ و با استفاده از طراحان گرافیک است
                        </p>
                        <span className={`mx-2 ${styles.consultanttextreportchats_time}`}>۱۳:۵۰</span>
                    </div>
                </div>
                <div dir="ltr" className={`d-flex align-items-start position-relative my-4 ${styles.consultanttextreportchats_box}`}>
                    <img className={`ms-1 ${styles.consultanttextreportchats_avatar}`} src={userProfile} alt="avatar-chat-img" />
                    <div style={{ width: "40%" }} className="text-right">
                        <p className={`d-flex bg-white mb-0 mx-2 px-3 py-2 text-right ${styles.consultanttextreportchats_text}`}>
                            لورم ایپسوم متن ساختگی با تولید سادگی نامفهوم از
                            صنعت چاپ و با استفاده از طراحان گرافیک است
                        </p>
                        <span className={`mx-2 ${styles.consultanttextreportchats_time}`}>۱۳:۵۱</span>
                    </div>
                </div>

                {/* Date */}
                <span className={`d-flex justify-content-center align-items-center bg-white my-0 mx-auto ${styles.consultanttextreportchats_date}`}>
                    امروز
                </span>
                {/* Box Right */}
                <div dir="rtl" className={`d-flex align-items-start position-relative my-4 ${styles.consultanttextreportchats_box}`}>
                    <img className={`ms-1 ${styles.consultanttextreportchats_avatar}`} src={userProfile} alt="avatar-chat-img" />
                    <div style={{ width: "40%" }}>
                        <p className={`d-flex bg-white mb-0 mx-2 px-3 py-2 text-right ${styles.consultanttextreportchats_text}`}>
                            لورم ایپسوم متن ساختگی با تولید سادگی نامفهوم از
                            صنعت چاپ و با استفاده از طراحان گرافیک است
                        </p>
                        <span className={`mx-2 ${styles.consultanttextreportchats_time}`}>۱۳:۵۰</span>
                    </div>
                </div>
                {/* Box Left */}
                <div dir="ltr" className={`d-flex align-items-start position-relative my-4 ${styles.consultanttextreportchats_box}`}>
                    <img className={`ms-1 ${styles.consultanttextreportchats_avatar}`} src={userProfile} alt="avatar-chat-img" />
                    <div style={{ width: "40%" }} className="text-right">
                        <p className={`d-flex bg-white mb-0 mx-2 px-3 py-2 text-right ${styles.consultanttextreportchats_text}`}>
                            لورم ایپسوم متن ساختگی با تولید سادگی نامفهوم از
                            صنعت چاپ و با استفاده از طراحان گرافیک است
                        </p>
                        <span className={`mx-2 ${styles.consultanttextreportchats_time}`}>۱۳:۵۱</span>
                    </div>
                </div>
                <div dir="ltr" className={`d-flex align-items-start position-relative my-4 ${styles.consultanttextreportchats_box}`}>
                    <img className={`ms-1 ${styles.consultanttextreportchats_avatar}`} src={userProfile} alt="avatar-chat-img" />
                    <div style={{ width: "40%" }} className="text-right">
                        <p className={`d-flex bg-white mb-0 mx-2 px-3 py-2 text-right ${styles.consultanttextreportchats_text}`}>
                            لورم ایپسوم متن ساختگی با تولید سادگی نامفهوم از
                            صنعت چاپ و با استفاده از طراحان گرافیک است
                        </p>
                        <span className={`mx-2 ${styles.consultanttextreportchats_time}`}>۱۳:۵۱</span>
                    </div>
                </div>
            </div>
        </div>
    )
}

export default ConsultantTextReportsDetailsChats